<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate>

      <div class="p-grid">
          <div class="p-col-6">
              <h2>{{ t('common.labels.basedata') }}</h2>
          </div>
          <div class="p-col-6 p-text-right">
            <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
          </div>
      </div>

      <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-6">
            <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')"></app-form-control>
          </div>
          <div class="p-col-12 p-md-6">
            <app-country-timezone [required]="true" [(country)]="country" [(timezone)]="timezone" [form]="form.get('tz')" [edit]="true"></app-country-timezone>
          </div>
      </div>

  </form>
</ng-container>
